export const lockersUrls = {
  login: '/client/login',
  machines: '/machines',
  listSlot: '/slot_list',
  slots: '/slots/',
}
